export let initialState = {
    appStore: {
        login: 'Arina',
        name: 'Arina Shapovalova'
    }
}